module.exports = __webpack_public_path__ + "img/couples-046.41939d8f.jpg";